import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import Landing from './pages/Landing'
import AssistedManualCensus from './pages/Census/AssistedManualCensus'
import Payroll from './pages/Payroll/Payroll'
import ApiVisibility from './pages/ApiVisibility'
import ApiVisibilityChildRoutes from './pages/ApiVisibility/routes'
import CensusSyncVisibility from './pages/CensusVisibilityPlumbing/pages/CensusSyncVisibility'
import { HRIS_PATH } from './constants'
import PageWrapper from 'enrollment-platform/PageWrapper'
import authOnEnter from 'enrollment-platform/authOnEnter'
import { abilityOnEnter } from 'enrollment-platform/rbac/abilityOnEnter'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'

const HRISRoutes = {
  path: HRIS_PATH,
  component: PageWrapper,
  onEnter(_nextState, replace, callback) {
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback,
    })
  },
  indexRoute: {
    component: Landing,
  },
  childRoutes: [
    {
      path: 'census',
      component: AssistedManualCensus,
      // US-restricted data: /hris/census and every sub-path require
      // Manage on UsRestrictedData. Without it, redirect to Home.
      onEnter(_nextState, replace, callback) {
        abilityOnEnter({
          action: RbacActions.Manage,
          subject: RbacSubjects.UsRestrictedData,
          replace,
          callback,
        })
      },
    },
    {
      path: 'payroll',
      component: Payroll,
    },
    {
      path: 'api-visibility',
      component: ApiVisibility,
      childRoutes: ApiVisibilityChildRoutes,
    },
    {
      path: 'census-visibility-plumbing',
      component: CensusSyncVisibility,
    },
  ],
}

export default HRISRoutes
